import { Draft } from '@/types';

export const getProductType = (draft: Draft) => draft.productType;
